import React from "react";
import { Button, Stack, Text } from "@metrea-ui/v2";
import { AppModal } from "src/components/UI/common/AppModal";
import { ModalShell } from "src/components/UI/common/ModalShell";

export const TimeoutWarningModal = ({ isOpen, onRequestClose }) => {
	return (
		<AppModal
			open={isOpen}
			onClose={onRequestClose}
			aria-labelledby="timeout-warning-title"
			aria-describedby="timeout-warning-description"
		>
			<ModalShell
				inset="auto"
				top="50%"
				left="50%"
				transform="translate(-50%, -50%)"
				w="500px"
				maxW="calc(100vw - 2rem)"
				maxH="80vh"
				px={12}
				py={10}
			>
				<Stack>
					<Text id="timeout-warning-title" textStyle="2xl">
						Session Timeout
					</Text>
					<Text id="timeout-warning-description" textStyle="md">
						You're being timed out due to inactivity. Please choose to stay signed in to continue.
						Otherwise, you will be logged off automatically
					</Text>
					<Button size="xl" onClick={onRequestClose}>
						Stay Logged In
					</Button>
				</Stack>
			</ModalShell>
		</AppModal>
	);
};
